import styled from "styled-components";

export const WaitingPaymentConteiner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80vh !important;

  > div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 24px;

    > svg {
      animation: spin 2s linear infinite;
    }

    @keyframes spin {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }

    > span {
      font-weight: 600;
      font-size: 24px;
      line-height: 28px;
      color: #222222;
      text-align: center;
    }

    > div {
      display: flex;
      flex-direction: column;
      gap: 24px;
      margin: auto;
      justify-content: center;

      > button {
        margin: auto;
      }
    }
  }
`;
